import { render, staticRenderFns } from "./UserEva.vue?vue&type=template&id=2744768b&scoped=true&"
import script from "./UserEva.vue?vue&type=script&lang=js&"
export * from "./UserEva.vue?vue&type=script&lang=js&"
import style0 from "./UserEva.vue?vue&type=style&index=0&id=2744768b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744768b",
  null
  
)

export default component.exports